import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useEffect,useState } from 'react';
import { Carousel, CarouselCaption, CarouselItem } from 'react-bootstrap';

function MatchSelection(props) {
    const [isLoading,setIsLoading] = useState(false)
    const [error,setError] = useState();
    const [match,setMatch] = useState();
    const [tempsRestant, setTempsRestant] = useState('');
    const apiUrl = process.env.REACT_APP_API_URL;


    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
          try {
            const response = await axios.get(
              `${apiUrl}/match/affichage/selection/${props.userData.user.donnée.results[0].id_championnat}`,
            );
            
            setError(null);
            setIsLoading(false);
            setMatch(response.data)
            


    
          } catch (error) {
            if (error.response) {
                
              setError(error.response.data.message);
            } else {
           
              setError(true)
            }
            setIsLoading(false);
    
          }
        };
    
        fetchData(); 
      }, [apiUrl, props]);

      useEffect(() => {
          if(match && match.ProchainMatch && match.ProchainMatch.length > 0){
            const interval = setInterval(() => {
              const temps = compteARebour(match.ProchainMatch[0].dateComplete);
              setTempsRestant(temps);
          }, 1000);
          return () => clearInterval(interval);
          
        }
        else{
          setTempsRestant("0 jours, 0 heures, 0 minutes, 0 secondes");
        }
      }, [match]);

      const compteARebour = (dateComplete) => {
        const [datePart, timePart] = dateComplete.split(' ');
        const [year, month, day] = datePart.split('-');
        const [hour, minute] = timePart.split(':');
        
        const dateFinObj = new Date(year, month - 1, day, hour, minute);
        const maintenant = new Date();
    
        let difference = dateFinObj - maintenant;
    
        if (difference <= 0) {
            return "0 jours, 0 heures, 0 minutes, 0 secondes";
        }
    
        const jours = Math.floor(difference / (1000 * 60 * 60 * 24));
        difference -= jours * (1000 * 60 * 60 * 24);
    
        const heures = Math.floor(difference / (1000 * 60 * 60));
        difference -= heures * (1000 * 60 * 60);
    
        const minutes = Math.floor(difference / (1000 * 60));
        difference -= minutes * (1000 * 60);
    
        const secondes = Math.floor(difference / 1000);
    
        return `${jours} jours, ${heures} heures, ${minutes} minutes, ${secondes} secondes`;
    };
    


  return (
    <>

    {tempsRestant && match ? (
      <>
        <Carousel  style={{width:"99%"}}>
        <CarouselItem> 
              <Card.Img variant="top" src="/img/selection.avif" style={{height:"auto", maxHeight:"680px"}} />
              <CarouselCaption>
              <h3>Optez pour la crème de la crème !</h3>
              <p>Sélectionnez les joueurs qui feront la différence sur le terrain et menez votre équipe vers la victoire.</p>
              </CarouselCaption>
            </CarouselItem>
          {match && match.ProchainMatch && match.ProchainMatch.length > 0 && (
              <CarouselItem >
                <Card.Img variant="top" src="/img/selection_next_match.jpg" style={{height:"auto", maxHeight:"680px"}} />
                <CarouselCaption>
                    <h3>Votre prochain rendez-vous : <strong>{match.ProchainMatch[0].equipe_dom} - {match.ProchainMatch[0].equipe_ext}</strong></h3>
                    <p><strong>{tempsRestant}</strong>.</p>
                </CarouselCaption>
              </CarouselItem>
          )}
        </Carousel>
      <br/>
        <Card className="text-center">
        <Card.Header><strong>Prochain match</strong></Card.Header>
        {match.ProchainMatch && match.ProchainMatch.length > 0 ? (
        <>
          <Card.Body >
            <Card.Title>{match.ProchainMatch[0].equipe_dom} - {match.ProchainMatch[0].equipe_ext}</Card.Title>
            <Card.Text>
                {match.ProchainMatch[0].competition}<br/>
                {match.ProchainMatch[0].date}
            </Card.Text>
            <Link to={`/${props.type}/tableau-de-bord/selection/details/${match.ProchainMatch[0].id_match}`}>
                    <Button  className="custom-btn" variant="primary" >{props.type === "coach" ? ("Gérer la sélection"):("Voir la sélection")}</Button>
              </Link>
          </Card.Body>
        
        <Card.Footer className="text-muted">Le match est dans {tempsRestant}.</Card.Footer>
        </>):(<>
        </>)}
        </Card>
        <br/>
        <Card>
        <Card.Header><strong>Match(s) suivant(s)</strong></Card.Header>
        {match.ProchainMatch && match.ProchainMatch.slice(1).map((item, index) => ( (
            <Card key={index}>
              <Card.Body>
                <Card.Title>{item.equipe_dom} {item.score === null ? (<>-</>):(<>{item.score}</>)} {item.equipe_ext}</Card.Title>
                <Card.Text>
                        {item.competition}<br/>
                       {item.date}
                </Card.Text>
              </Card.Body>
            </Card>
            )))}
        </Card>
        <br/>
        <Card>
          <Card.Header><strong>Ancien(s) Match</strong></Card.Header>
          {match.ancienMatch && match.ancienMatch.map((item, index) => ( (
            <Card key={index}>
              <Card.Body>
                <Card.Title>{item.equipe_dom} {item.score === null ? (<>? - ?</>):(<>{item.score}</>)} {item.equipe_ext}</Card.Title>
                <Card.Text>
                  {item.competition}<br/>
                  {item.date}
                </Card.Text>
                <div style={{textAlign:"right"}}>
                  <Link to={`/${props.type}/tableau-de-bord/selection/historique/details/${item.id_match}`}>
                      <Button  className="custom-btn" variant="primary" >Voir la sélection</Button>
                </Link>
              </div>
              </Card.Body>
            </Card>
          )))}

        </Card>
        <br/>
    </>
  ):(<></>)}
    {error && (
        <div id="alert-message" className="alert5" >
            <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
        </div>
    )}
    {isLoading && (
        <div className="centered-content">
          <img src="/img/logo.png" alt="Logo" className="centered-logo" />
          <br/>
          <span className="loader"></span>
        </div>
    )}
  </>
  );
}

export default MatchSelection;